import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = ["src"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_van_nav_bar = _resolveComponent("van-nav-bar")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_van_nav_bar, {
      title: _ctx.listObject.name,
      "left-arrow": "",
      onClickLeft: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$router.back()))
    }, null, 8, ["title"]),
    _createElementVNode("video", {
      src: _ctx.listObject.url,
      class: "video",
      controls: "controls",
      autoplay: ""
    }, null, 8, _hoisted_1)
  ], 64))
}